/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OrderResultModel from './OrderResultModel';
import OrderStatusErrorModel from './OrderStatusErrorModel';

/**
* The OrderStatusResultModel model module.
* @module model/OrderStatusResultModel
* @version 1.0.0
*/
export default class OrderStatusResultModel {
    /**
    * Constructs a new <code>OrderStatusResultModel</code>.
    * @alias module:model/OrderStatusResultModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>OrderStatusResultModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/OrderStatusResultModel} obj Optional instance to populate.
    * @return {module:model/OrderStatusResultModel} The populated <code>OrderStatusResultModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrderStatusResultModel();
                        
            
            if (data.hasOwnProperty('Status')) {
                obj['Status'] = ApiClient.convertToType(data['Status'], 'String');
            }
            if (data.hasOwnProperty('OrderId')) {
                obj['OrderId'] = ApiClient.convertToType(data['OrderId'], 'String');
            }
            if (data.hasOwnProperty('Order')) {
                obj['Order'] = OrderResultModel.constructFromObject(data['Order']);
            }
            if (data.hasOwnProperty('Errors')) {
                obj['Errors'] = ApiClient.convertToType(data['Errors'], [OrderStatusErrorModel]);
            }
        }
        return obj;
    }

    /**
    * @member {String} Status
    */
    'Status' = undefined;
    /**
    * @member {String} OrderId
    */
    'OrderId' = undefined;
    /**
    * @member {module:model/OrderResultModel} Order
    */
    'Order' = undefined;
    /**
    * @member {Array.<module:model/OrderStatusErrorModel>} Errors
    */
    'Errors' = undefined;




}
